import type {ReactElement} from 'react';
import {SchedulePopover} from '@Components/schedule-popover/schedule-popover';
import {CACHE_KEY_FOR_SCHEDULING} from '@Libraries/social-media-grid.library';
import {getSchedulingDateForPrefill} from '@Libraries/social-media-wizard-scheduling-library';
import type {WizardDateTimePickerProps} from './wizard-date-time-picker.types';

export function WizardDateTimePicker({anchorRef, isOpen, scheduledDate, isEditingExistingSchedule, onClose, onScheduleAt, onDeleteSchedule}: WizardDateTimePickerProps): ReactElement | null {
  const getInitialDate = (): Date | null => {
    if (scheduledDate) {
      return scheduledDate;
    }

    const prefilledDate = window.PMW.getCacheItem(CACHE_KEY_FOR_SCHEDULING) as string;

    return prefilledDate ? getSchedulingDateForPrefill(prefilledDate) : null;
  };

  const scheduleAtSelectedDateTime = (dateTime: Date): void => {
    onClose();
    onScheduleAt(dateTime);
  };

  const removeSchedule = (): void => {
    onClose();
    onDeleteSchedule();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <SchedulePopover
      anchorRef={anchorRef}
      onClose={onClose}
      initialDate={getInitialDate()}
      isEditingExistingSchedule={isEditingExistingSchedule}
      onSave={scheduleAtSelectedDateTime}
      onRemove={removeSchedule}
    />
  );
}
